/*!
 * modernizr v3.6.0
 * Build https://modernizr.com/download?-objectfit-touchevents-setclasses-dontmin
 *
 * Copyright (c)
 *  Faruk Ates
 *  Paul Irish
 *  Alex Sexton
 *  Ryan Seddon
 *  Patrick Kettner
 *  Stu Cox
 *  Richard Herrera

 * MIT License
 */

/*
 * Modernizr tests which native CSS3 and HTML5 features are available in the
 * current UA and makes the results available to you in two ways: as properties on
 * a global `Modernizr` object, and as classes on the `<html>` element. This
 * information allows you to progressively enhance your pages with a granular level
 * of control over the experience.
*/

;(function(window, document, undefined){
  var classes = [];
  

  var tests = [];
  

  /**
   *
   * ModernizrProto is the constructor for Modernizr
   *
   * @class
   * @access public
   */

  var ModernizrProto = {
    // The current version, dummy
    _version: '3.6.0',

    // Any settings that don't work as separate modules
    // can go in here as configuration.
    _config: {
      'classPrefix': '',
      'enableClasses': true,
      'enableJSClass': true,
      'usePrefixes': true
    },

    // Queue of tests
    _q: [],

    // Stub these for people who are listening
    on: function(test, cb) {
      // I don't really think people should do this, but we can
      // safe guard it a bit.
      // -- NOTE:: this gets WAY overridden in src/addTest for actual async tests.
      // This is in case people listen to synchronous tests. I would leave it out,
      // but the code to *disallow* sync tests in the real version of this
      // function is actually larger than this.
      var self = this;
      setTimeout(function() {
        cb(self[test]);
      }, 0);
    },

    addTest: function(name, fn, options) {
      tests.push({name: name, fn: fn, options: options});
    },

    addAsyncTest: function(fn) {
      tests.push({name: null, fn: fn});
    }
  };

  

  // Fake some of Object.create so we can force non test results to be non "own" properties.
  var Modernizr = function() {};
  Modernizr.prototype = ModernizrProto;

  // Leak modernizr globally when you `require` it rather than force it here.
  // Overwrite name so constructor name is nicer :D
  Modernizr = new Modernizr();

  

  /**
   * is returns a boolean if the typeof an obj is exactly type.
   *
   * @access private
   * @function is
   * @param {*} obj - A thing we want to check the type of
   * @param {string} type - A string to compare the typeof against
   * @returns {boolean}
   */

  function is(obj, type) {
    return typeof obj === type;
  }
  ;

  /**
   * Run through all tests and detect their support in the current UA.
   *
   * @access private
   */

  function testRunner() {
    var featureNames;
    var feature;
    var aliasIdx;
    var result;
    var nameIdx;
    var featureName;
    var featureNameSplit;

    for (var featureIdx in tests) {
      if (tests.hasOwnProperty(featureIdx)) {
        featureNames = [];
        feature = tests[featureIdx];
        // run the test, throw the return value into the Modernizr,
        // then based on that boolean, define an appropriate className
        // and push it into an array of classes we'll join later.
        //
        // If there is no name, it's an 'async' test that is run,
        // but not directly added to the object. That should
        // be done with a post-run addTest call.
        if (feature.name) {
          featureNames.push(feature.name.toLowerCase());

          if (feature.options && feature.options.aliases && feature.options.aliases.length) {
            // Add all the aliases into the names list
            for (aliasIdx = 0; aliasIdx < feature.options.aliases.length; aliasIdx++) {
              featureNames.push(feature.options.aliases[aliasIdx].toLowerCase());
            }
          }
        }

        // Run the test, or use the raw value if it's not a function
        result = is(feature.fn, 'function') ? feature.fn() : feature.fn;


        // Set each of the names on the Modernizr object
        for (nameIdx = 0; nameIdx < featureNames.length; nameIdx++) {
          featureName = featureNames[nameIdx];
          // Support dot properties as sub tests. We don't do checking to make sure
          // that the implied parent tests have been added. You must call them in
          // order (either in the test, or make the parent test a dependency).
          //
          // Cap it to TWO to make the logic simple and because who needs that kind of subtesting
          // hashtag famous last words
          featureNameSplit = featureName.split('.');

          if (featureNameSplit.length === 1) {
            Modernizr[featureNameSplit[0]] = result;
          } else {
            // cast to a Boolean, if not one already
            if (Modernizr[featureNameSplit[0]] && !(Modernizr[featureNameSplit[0]] instanceof Boolean)) {
              Modernizr[featureNameSplit[0]] = new Boolean(Modernizr[featureNameSplit[0]]);
            }

            Modernizr[featureNameSplit[0]][featureNameSplit[1]] = result;
          }

          classes.push((result ? '' : 'no-') + featureNameSplit.join('-'));
        }
      }
    }
  }
  ;

  /**
   * docElement is a convenience wrapper to grab the root element of the document
   *
   * @access private
   * @returns {HTMLElement|SVGElement} The root element of the document
   */

  var docElement = document.documentElement;
  

  /**
   * A convenience helper to check if the document we are running in is an SVG document
   *
   * @access private
   * @returns {boolean}
   */

  var isSVG = docElement.nodeName.toLowerCase() === 'svg';
  

  /**
   * setClasses takes an array of class names and adds them to the root element
   *
   * @access private
   * @function setClasses
   * @param {string[]} classes - Array of class names
   */

  // Pass in an and array of class names, e.g.:
  //  ['no-webp', 'borderradius', ...]
  function setClasses(classes) {
    var className = docElement.className;
    var classPrefix = Modernizr._config.classPrefix || '';

    if (isSVG) {
      className = className.baseVal;
    }

    // Change `no-js` to `js` (independently of the `enableClasses` option)
    // Handle classPrefix on this too
    if (Modernizr._config.enableJSClass) {
      var reJS = new RegExp('(^|\\s)' + classPrefix + 'no-js(\\s|$)');
      className = className.replace(reJS, '$1' + classPrefix + 'js$2');
    }

    if (Modernizr._config.enableClasses) {
      // Add the new classes
      className += ' ' + classPrefix + classes.join(' ' + classPrefix);
      if (isSVG) {
        docElement.className.baseVal = className;
      } else {
        docElement.className = className;
      }
    }

  }

  ;

  /**
   * List of property values to set for css tests. See ticket #21
   * http://git.io/vUGl4
   *
   * @memberof Modernizr
   * @name Modernizr._prefixes
   * @optionName Modernizr._prefixes
   * @optionProp prefixes
   * @access public
   * @example
   *
   * Modernizr._prefixes is the internal list of prefixes that we test against
   * inside of things like [prefixed](#modernizr-prefixed) and [prefixedCSS](#-code-modernizr-prefixedcss). It is simply
   * an array of kebab-case vendor prefixes you can use within your code.
   *
   * Some common use cases include
   *
   * Generating all possible prefixed version of a CSS property
   * ```js
   * var rule = Modernizr._prefixes.join('transform: rotate(20deg); ');
   *
   * rule === 'transform: rotate(20deg); webkit-transform: rotate(20deg); moz-transform: rotate(20deg); o-transform: rotate(20deg); ms-transform: rotate(20deg);'
   * ```
   *
   * Generating all possible prefixed version of a CSS value
   * ```js
   * rule = 'display:' +  Modernizr._prefixes.join('flex; display:') + 'flex';
   *
   * rule === 'display:flex; display:-webkit-flex; display:-moz-flex; display:-o-flex; display:-ms-flex; display:flex'
   * ```
   */

  // we use ['',''] rather than an empty array in order to allow a pattern of .`join()`ing prefixes to test
  // values in feature detects to continue to work
  var prefixes = (ModernizrProto._config.usePrefixes ? ' -webkit- -moz- -o- -ms- '.split(' ') : ['','']);

  // expose these for the plugin API. Look in the source for how to join() them against your input
  ModernizrProto._prefixes = prefixes;

  

  /**
   * createElement is a convenience wrapper around document.createElement. Since we
   * use createElement all over the place, this allows for (slightly) smaller code
   * as well as abstracting away issues with creating elements in contexts other than
   * HTML documents (e.g. SVG documents).
   *
   * @access private
   * @function createElement
   * @returns {HTMLElement|SVGElement} An HTML or SVG element
   */

  function createElement() {
    if (typeof document.createElement !== 'function') {
      // This is the case in IE7, where the type of createElement is "object".
      // For this reason, we cannot call apply() as Object is not a Function.
      return document.createElement(arguments[0]);
    } else if (isSVG) {
      return document.createElementNS.call(document, 'http://www.w3.org/2000/svg', arguments[0]);
    } else {
      return document.createElement.apply(document, arguments);
    }
  }

  ;

  /**
   * getBody returns the body of a document, or an element that can stand in for
   * the body if a real body does not exist
   *
   * @access private
   * @function getBody
   * @returns {HTMLElement|SVGElement} Returns the real body of a document, or an
   * artificially created element that stands in for the body
   */

  function getBody() {
    // After page load injecting a fake body doesn't work so check if body exists
    var body = document.body;

    if (!body) {
      // Can't use the real body create a fake one.
      body = createElement(isSVG ? 'svg' : 'body');
      body.fake = true;
    }

    return body;
  }

  ;

  /**
   * injectElementWithStyles injects an element with style element and some CSS rules
   *
   * @access private
   * @function injectElementWithStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   */

  function injectElementWithStyles(rule, callback, nodes, testnames) {
    var mod = 'modernizr';
    var style;
    var ret;
    var node;
    var docOverflow;
    var div = createElement('div');
    var body = getBody();

    if (parseInt(nodes, 10)) {
      // In order not to give false positives we create a node for each test
      // This also allows the method to scale for unspecified uses
      while (nodes--) {
        node = createElement('div');
        node.id = testnames ? testnames[nodes] : mod + (nodes + 1);
        div.appendChild(node);
      }
    }

    style = createElement('style');
    style.type = 'text/css';
    style.id = 's' + mod;

    // IE6 will false positive on some tests due to the style element inside the test div somehow interfering offsetHeight, so insert it into body or fakebody.
    // Opera will act all quirky when injecting elements in documentElement when page is served as xml, needs fakebody too. #270
    (!body.fake ? div : body).appendChild(style);
    body.appendChild(div);

    if (style.styleSheet) {
      style.styleSheet.cssText = rule;
    } else {
      style.appendChild(document.createTextNode(rule));
    }
    div.id = mod;

    if (body.fake) {
      //avoid crashing IE8, if background image is used
      body.style.background = '';
      //Safari 5.13/5.1.4 OSX stops loading if ::-webkit-scrollbar is used and scrollbars are visible
      body.style.overflow = 'hidden';
      docOverflow = docElement.style.overflow;
      docElement.style.overflow = 'hidden';
      docElement.appendChild(body);
    }

    ret = callback(div, rule);
    // If this is done after page load we don't want to remove the body so check if body exists
    if (body.fake) {
      body.parentNode.removeChild(body);
      docElement.style.overflow = docOverflow;
      // Trigger layout so kinetic scrolling isn't disabled in iOS6+
      // eslint-disable-next-line
      docElement.offsetHeight;
    } else {
      div.parentNode.removeChild(div);
    }

    return !!ret;

  }

  ;

  /**
   * testStyles injects an element with style element and some CSS rules
   *
   * @memberof Modernizr
   * @name Modernizr.testStyles
   * @optionName Modernizr.testStyles()
   * @optionProp testStyles
   * @access public
   * @function testStyles
   * @param {string} rule - String representing a css rule
   * @param {function} callback - A function that is used to test the injected element
   * @param {number} [nodes] - An integer representing the number of additional nodes you want injected
   * @param {string[]} [testnames] - An array of strings that are used as ids for the additional nodes
   * @returns {boolean}
   * @example
   *
   * `Modernizr.testStyles` takes a CSS rule and injects it onto the current page
   * along with (possibly multiple) DOM elements. This lets you check for features
   * that can not be detected by simply checking the [IDL](https://developer.mozilla.org/en-US/docs/Mozilla/Developer_guide/Interface_development_guide/IDL_interface_rules).
   *
   * ```js
   * Modernizr.testStyles('#modernizr { width: 9px; color: papayawhip; }', function(elem, rule) {
   *   // elem is the first DOM node in the page (by default #modernizr)
   *   // rule is the first argument you supplied - the CSS rule in string form
   *
   *   addTest('widthworks', elem.style.width === '9px')
   * });
   * ```
   *
   * If your test requires multiple nodes, you can include a third argument
   * indicating how many additional div elements to include on the page. The
   * additional nodes are injected as children of the `elem` that is returned as
   * the first argument to the callback.
   *
   * ```js
   * Modernizr.testStyles('#modernizr {width: 1px}; #modernizr2 {width: 2px}', function(elem) {
   *   document.getElementById('modernizr').style.width === '1px'; // true
   *   document.getElementById('modernizr2').style.width === '2px'; // true
   *   elem.firstChild === document.getElementById('modernizr2'); // true
   * }, 1);
   * ```
   *
   * By default, all of the additional elements have an ID of `modernizr[n]`, where
   * `n` is its index (e.g. the first additional, second overall is `#modernizr2`,
   * the second additional is `#modernizr3`, etc.).
   * If you want to have more meaningful IDs for your function, you can provide
   * them as the fourth argument, as an array of strings
   *
   * ```js
   * Modernizr.testStyles('#foo {width: 10px}; #bar {height: 20px}', function(elem) {
   *   elem.firstChild === document.getElementById('foo'); // true
   *   elem.lastChild === document.getElementById('bar'); // true
   * }, 2, ['foo', 'bar']);
   * ```
   *
   */

  var testStyles = ModernizrProto.testStyles = injectElementWithStyles;
  
/*!
{
  "name": "Touch Events",
  "property": "touchevents",
  "caniuse" : "touch",
  "tags": ["media", "attribute"],
  "notes": [{
    "name": "Touch Events spec",
    "href": "https://www.w3.org/TR/2013/WD-touch-events-20130124/"
  }],
  "warnings": [
    "Indicates if the browser supports the Touch Events spec, and does not necessarily reflect a touchscreen device"
  ],
  "knownBugs": [
    "False-positive on some configurations of Nokia N900",
    "False-positive on some BlackBerry 6.0 builds – https://github.com/Modernizr/Modernizr/issues/372#issuecomment-3112695"
  ]
}
!*/
/* DOC
Indicates if the browser supports the W3C Touch Events API.

This *does not* necessarily reflect a touchscreen device:

* Older touchscreen devices only emulate mouse events
* Modern IE touch devices implement the Pointer Events API instead: use `Modernizr.pointerevents` to detect support for that
* Some browsers & OS setups may enable touch APIs when no touchscreen is connected
* Future browsers may implement other event models for touch interactions

See this article: [You Can't Detect A Touchscreen](http://www.stucox.com/blog/you-cant-detect-a-touchscreen/).

It's recommended to bind both mouse and touch/pointer events simultaneously – see [this HTML5 Rocks tutorial](http://www.html5rocks.com/en/mobile/touchandmouse/).

This test will also return `true` for Firefox 4 Multitouch support.
*/

  // Chrome (desktop) used to lie about its support on this, but that has since been rectified: http://crbug.com/36415
  Modernizr.addTest('touchevents', function() {
    var bool;
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
      bool = true;
    } else {
      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      var query = ['@media (', prefixes.join('touch-enabled),('), 'heartz', ')', '{#modernizr{top:9px;position:absolute}}'].join('');
      testStyles(query, function(node) {
        bool = node.offsetTop === 9;
      });
    }
    return bool;
  });


  /**
   * cssToDOM takes a kebab-case string and converts it to camelCase
   * e.g. box-sizing -> boxSizing
   *
   * @access private
   * @function cssToDOM
   * @param {string} name - String name of kebab-case prop we want to convert
   * @returns {string} The camelCase version of the supplied name
   */

  function cssToDOM(name) {
    return name.replace(/([a-z])-([a-z])/g, function(str, m1, m2) {
      return m1 + m2.toUpperCase();
    }).replace(/^-/, '');
  }
  ;

  /**
   * If the browsers follow the spec, then they would expose vendor-specific styles as:
   *   elem.style.WebkitBorderRadius
   * instead of something like the following (which is technically incorrect):
   *   elem.style.webkitBorderRadius

   * WebKit ghosts their properties in lowercase but Opera & Moz do not.
   * Microsoft uses a lowercase `ms` instead of the correct `Ms` in IE8+
   *   erik.eae.net/archives/2008/03/10/21.48.10/

   * More here: github.com/Modernizr/Modernizr/issues/issue/21
   *
   * @access private
   * @returns {string} The string representing the vendor-specific style properties
   */

  var omPrefixes = 'Moz O ms Webkit';
  

  var cssomPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.split(' ') : []);
  ModernizrProto._cssomPrefixes = cssomPrefixes;
  

  /**
   * atRule returns a given CSS property at-rule (eg @keyframes), possibly in
   * some prefixed form, or false, in the case of an unsupported rule
   *
   * @memberof Modernizr
   * @name Modernizr.atRule
   * @optionName Modernizr.atRule()
   * @optionProp atRule
   * @access public
   * @function atRule
   * @param {string} prop - String name of the @-rule to test for
   * @returns {string|boolean} The string representing the (possibly prefixed)
   * valid version of the @-rule, or `false` when it is unsupported.
   * @example
   * ```js
   *  var keyframes = Modernizr.atRule('@keyframes');
   *
   *  if (keyframes) {
   *    // keyframes are supported
   *    // could be `@-webkit-keyframes` or `@keyframes`
   *  } else {
   *    // keyframes === `false`
   *  }
   * ```
   *
   */

  var atRule = function(prop) {
    var length = prefixes.length;
    var cssrule = window.CSSRule;
    var rule;

    if (typeof cssrule === 'undefined') {
      return undefined;
    }

    if (!prop) {
      return false;
    }

    // remove literal @ from beginning of provided property
    prop = prop.replace(/^@/, '');

    // CSSRules use underscores instead of dashes
    rule = prop.replace(/-/g, '_').toUpperCase() + '_RULE';

    if (rule in cssrule) {
      return '@' + prop;
    }

    for (var i = 0; i < length; i++) {
      // prefixes gives us something like -o-, and we want O_
      var prefix = prefixes[i];
      var thisRule = prefix.toUpperCase() + '_' + rule;

      if (thisRule in cssrule) {
        return '@-' + prefix.toLowerCase() + '-' + prop;
      }
    }

    return false;
  };

  ModernizrProto.atRule = atRule;

  

  /**
   * List of JavaScript DOM values used for tests
   *
   * @memberof Modernizr
   * @name Modernizr._domPrefixes
   * @optionName Modernizr._domPrefixes
   * @optionProp domPrefixes
   * @access public
   * @example
   *
   * Modernizr._domPrefixes is exactly the same as [_prefixes](#modernizr-_prefixes), but rather
   * than kebab-case properties, all properties are their Capitalized variant
   *
   * ```js
   * Modernizr._domPrefixes === [ "Moz", "O", "ms", "Webkit" ];
   * ```
   */

  var domPrefixes = (ModernizrProto._config.usePrefixes ? omPrefixes.toLowerCase().split(' ') : []);
  ModernizrProto._domPrefixes = domPrefixes;
  


  /**
   * contains checks to see if a string contains another string
   *
   * @access private
   * @function contains
   * @param {string} str - The string we want to check for substrings
   * @param {string} substr - The substring we want to search the first string for
   * @returns {boolean}
   */

  function contains(str, substr) {
    return !!~('' + str).indexOf(substr);
  }

  ;

  /**
   * fnBind is a super small [bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind) polyfill.
   *
   * @access private
   * @function fnBind
   * @param {function} fn - a function you want to change `this` reference to
   * @param {object} that - the `this` you want to call the function with
   * @returns {function} The wrapped version of the supplied function
   */

  function fnBind(fn, that) {
    return function() {
      return fn.apply(that, arguments);
    };
  }

  ;

  /**
   * testDOMProps is a generic DOM property test; if a browser supports
   *   a certain property, it won't return undefined for it.
   *
   * @access private
   * @function testDOMProps
   * @param {array.<string>} props - An array of properties to test for
   * @param {object} obj - An object or Element you want to use to test the parameters again
   * @param {boolean|object} elem - An Element to bind the property lookup again. Use `false` to prevent the check
   * @returns {false|*} returns false if the prop is unsupported, otherwise the value that is supported
   */
  function testDOMProps(props, obj, elem) {
    var item;

    for (var i in props) {
      if (props[i] in obj) {

        // return the property name as a string
        if (elem === false) {
          return props[i];
        }

        item = obj[props[i]];

        // let's bind a function
        if (is(item, 'function')) {
          // bind to obj unless overriden
          return fnBind(item, elem || obj);
        }

        // return the unbound function or obj or value
        return item;
      }
    }
    return false;
  }

  ;

  /**
   * Create our "modernizr" element that we do most feature tests on.
   *
   * @access private
   */

  var modElem = {
    elem: createElement('modernizr')
  };

  // Clean up this element
  Modernizr._q.push(function() {
    delete modElem.elem;
  });

  

  var mStyle = {
    style: modElem.elem.style
  };

  // kill ref for gc, must happen before mod.elem is removed, so we unshift on to
  // the front of the queue.
  Modernizr._q.unshift(function() {
    delete mStyle.style;
  });

  

  /**
   * domToCSS takes a camelCase string and converts it to kebab-case
   * e.g. boxSizing -> box-sizing
   *
   * @access private
   * @function domToCSS
   * @param {string} name - String name of camelCase prop we want to convert
   * @returns {string} The kebab-case version of the supplied name
   */

  function domToCSS(name) {
    return name.replace(/([A-Z])/g, function(str, m1) {
      return '-' + m1.toLowerCase();
    }).replace(/^ms-/, '-ms-');
  }
  ;


  /**
   * wrapper around getComputedStyle, to fix issues with Firefox returning null when
   * called inside of a hidden iframe
   *
   * @access private
   * @function computedStyle
   * @param {HTMLElement|SVGElement} - The element we want to find the computed styles of
   * @param {string|null} [pseudoSelector]- An optional pseudo element selector (e.g. :before), of null if none
   * @returns {CSSStyleDeclaration}
   */

  function computedStyle(elem, pseudo, prop) {
    var result;

    if ('getComputedStyle' in window) {
      result = getComputedStyle.call(window, elem, pseudo);
      var console = window.console;

      if (result !== null) {
        if (prop) {
          result = result.getPropertyValue(prop);
        }
      } else {
        if (console) {
          var method = console.error ? 'error' : 'log';
          console[method].call(console, 'getComputedStyle returning null, its possible modernizr test results are inaccurate');
        }
      }
    } else {
      result = !pseudo && elem.currentStyle && elem.currentStyle[prop];
    }

    return result;
  }

  ;

  /**
   * nativeTestProps allows for us to use native feature detection functionality if available.
   * some prefixed form, or false, in the case of an unsupported rule
   *
   * @access private
   * @function nativeTestProps
   * @param {array} props - An array of property names
   * @param {string} value - A string representing the value we want to check via @supports
   * @returns {boolean|undefined} A boolean when @supports exists, undefined otherwise
   */

  // Accepts a list of property names and a single value
  // Returns `undefined` if native detection not available
  function nativeTestProps(props, value) {
    var i = props.length;
    // Start with the JS API: http://www.w3.org/TR/css3-conditional/#the-css-interface
    if ('CSS' in window && 'supports' in window.CSS) {
      // Try every prefixed variant of the property
      while (i--) {
        if (window.CSS.supports(domToCSS(props[i]), value)) {
          return true;
        }
      }
      return false;
    }
    // Otherwise fall back to at-rule (for Opera 12.x)
    else if ('CSSSupportsRule' in window) {
      // Build a condition string for every prefixed variant
      var conditionText = [];
      while (i--) {
        conditionText.push('(' + domToCSS(props[i]) + ':' + value + ')');
      }
      conditionText = conditionText.join(' or ');
      return injectElementWithStyles('@supports (' + conditionText + ') { #modernizr { position: absolute; } }', function(node) {
        return computedStyle(node, null, 'position') == 'absolute';
      });
    }
    return undefined;
  }
  ;

  // testProps is a generic CSS / DOM property test.

  // In testing support for a given CSS property, it's legit to test:
  //    `elem.style[styleName] !== undefined`
  // If the property is supported it will return an empty string,
  // if unsupported it will return undefined.

  // We'll take advantage of this quick test and skip setting a style
  // on our modernizr element, but instead just testing undefined vs
  // empty string.

  // Property names can be provided in either camelCase or kebab-case.

  function testProps(props, prefixed, value, skipValueTest) {
    skipValueTest = is(skipValueTest, 'undefined') ? false : skipValueTest;

    // Try native detect first
    if (!is(value, 'undefined')) {
      var result = nativeTestProps(props, value);
      if (!is(result, 'undefined')) {
        return result;
      }
    }

    // Otherwise do it properly
    var afterInit, i, propsLength, prop, before;

    // If we don't have a style element, that means we're running async or after
    // the core tests, so we'll need to create our own elements to use

    // inside of an SVG element, in certain browsers, the `style` element is only
    // defined for valid tags. Therefore, if `modernizr` does not have one, we
    // fall back to a less used element and hope for the best.
    // for strict XHTML browsers the hardly used samp element is used
    var elems = ['modernizr', 'tspan', 'samp'];
    while (!mStyle.style && elems.length) {
      afterInit = true;
      mStyle.modElem = createElement(elems.shift());
      mStyle.style = mStyle.modElem.style;
    }

    // Delete the objects if we created them.
    function cleanElems() {
      if (afterInit) {
        delete mStyle.style;
        delete mStyle.modElem;
      }
    }

    propsLength = props.length;
    for (i = 0; i < propsLength; i++) {
      prop = props[i];
      before = mStyle.style[prop];

      if (contains(prop, '-')) {
        prop = cssToDOM(prop);
      }

      if (mStyle.style[prop] !== undefined) {

        // If value to test has been passed in, do a set-and-check test.
        // 0 (integer) is a valid property value, so check that `value` isn't
        // undefined, rather than just checking it's truthy.
        if (!skipValueTest && !is(value, 'undefined')) {

          // Needs a try catch block because of old IE. This is slow, but will
          // be avoided in most cases because `skipValueTest` will be used.
          try {
            mStyle.style[prop] = value;
          } catch (e) {}

          // If the property value has changed, we assume the value used is
          // supported. If `value` is empty string, it'll fail here (because
          // it hasn't changed), which matches how browsers have implemented
          // CSS.supports()
          if (mStyle.style[prop] != before) {
            cleanElems();
            return prefixed == 'pfx' ? prop : true;
          }
        }
        // Otherwise just return true, or the property name if this is a
        // `prefixed()` call
        else {
          cleanElems();
          return prefixed == 'pfx' ? prop : true;
        }
      }
    }
    cleanElems();
    return false;
  }

  ;

  /**
   * testPropsAll tests a list of DOM properties we want to check against.
   * We specify literally ALL possible (known and/or likely) properties on
   * the element including the non-vendor prefixed one, for forward-
   * compatibility.
   *
   * @access private
   * @function testPropsAll
   * @param {string} prop - A string of the property to test for
   * @param {string|object} [prefixed] - An object to check the prefixed properties on. Use a string to skip
   * @param {HTMLElement|SVGElement} [elem] - An element used to test the property and value against
   * @param {string} [value] - A string of a css value
   * @param {boolean} [skipValueTest] - An boolean representing if you want to test if value sticks when set
   * @returns {false|string} returns the string version of the property, or false if it is unsupported
   */
  function testPropsAll(prop, prefixed, elem, value, skipValueTest) {

    var ucProp = prop.charAt(0).toUpperCase() + prop.slice(1),
      props = (prop + ' ' + cssomPrefixes.join(ucProp + ' ') + ucProp).split(' ');

    // did they call .prefixed('boxSizing') or are we just testing a prop?
    if (is(prefixed, 'string') || is(prefixed, 'undefined')) {
      return testProps(props, prefixed, value, skipValueTest);

      // otherwise, they called .prefixed('requestAnimationFrame', window[, elem])
    } else {
      props = (prop + ' ' + (domPrefixes).join(ucProp + ' ') + ucProp).split(' ');
      return testDOMProps(props, prefixed, elem);
    }
  }

  // Modernizr.testAllProps() investigates whether a given style property,
  // or any of its vendor-prefixed variants, is recognized
  //
  // Note that the property names must be provided in the camelCase variant.
  // Modernizr.testAllProps('boxSizing')
  ModernizrProto.testAllProps = testPropsAll;

  

  /**
   * prefixed returns the prefixed or nonprefixed property name variant of your input
   *
   * @memberof Modernizr
   * @name Modernizr.prefixed
   * @optionName Modernizr.prefixed()
   * @optionProp prefixed
   * @access public
   * @function prefixed
   * @param {string} prop - String name of the property to test for
   * @param {object} [obj] - An object to test for the prefixed properties on
   * @param {HTMLElement} [elem] - An element used to test specific properties against
   * @returns {string|false} The string representing the (possibly prefixed) valid
   * version of the property, or `false` when it is unsupported.
   * @example
   *
   * Modernizr.prefixed takes a string css value in the DOM style camelCase (as
   * opposed to the css style kebab-case) form and returns the (possibly prefixed)
   * version of that property that the browser actually supports.
   *
   * For example, in older Firefox...
   * ```js
   * prefixed('boxSizing')
   * ```
   * returns 'MozBoxSizing'
   *
   * In newer Firefox, as well as any other browser that support the unprefixed
   * version would simply return `boxSizing`. Any browser that does not support
   * the property at all, it will return `false`.
   *
   * By default, prefixed is checked against a DOM element. If you want to check
   * for a property on another object, just pass it as a second argument
   *
   * ```js
   * var rAF = prefixed('requestAnimationFrame', window);
   *
   * raf(function() {
   *  renderFunction();
   * })
   * ```
   *
   * Note that this will return _the actual function_ - not the name of the function.
   * If you need the actual name of the property, pass in `false` as a third argument
   *
   * ```js
   * var rAFProp = prefixed('requestAnimationFrame', window, false);
   *
   * rafProp === 'WebkitRequestAnimationFrame' // in older webkit
   * ```
   *
   * One common use case for prefixed is if you're trying to determine which transition
   * end event to bind to, you might do something like...
   * ```js
   * var transEndEventNames = {
   *     'WebkitTransition' : 'webkitTransitionEnd', * Saf 6, Android Browser
   *     'MozTransition'    : 'transitionend',       * only for FF < 15
   *     'transition'       : 'transitionend'        * IE10, Opera, Chrome, FF 15+, Saf 7+
   * };
   *
   * var transEndEventName = transEndEventNames[ Modernizr.prefixed('transition') ];
   * ```
   *
   * If you want a similar lookup, but in kebab-case, you can use [prefixedCSS](#modernizr-prefixedcss).
   */

  var prefixed = ModernizrProto.prefixed = function(prop, obj, elem) {
    if (prop.indexOf('@') === 0) {
      return atRule(prop);
    }

    if (prop.indexOf('-') != -1) {
      // Convert kebab-case to camelCase
      prop = cssToDOM(prop);
    }
    if (!obj) {
      return testPropsAll(prop, 'pfx');
    } else {
      // Testing DOM property e.g. Modernizr.prefixed('requestAnimationFrame', window) // 'mozRequestAnimationFrame'
      return testPropsAll(prop, obj, elem);
    }
  };

  
/*!
{
  "name": "CSS Object Fit",
  "caniuse": "object-fit",
  "property": "objectfit",
  "tags": ["css"],
  "builderAliases": ["css_objectfit"],
  "notes": [{
    "name": "Opera Article on Object Fit",
    "href": "https://dev.opera.com/articles/css3-object-fit-object-position/"
  }]
}
!*/

  Modernizr.addTest('objectfit', !!prefixed('objectFit'), {aliases: ['object-fit']});


  // Run each test
  testRunner();

  // Remove the "no-js" class if it exists
  setClasses(classes);

  delete ModernizrProto.addTest;
  delete ModernizrProto.addAsyncTest;

  // Run the things that are supposed to run after the tests
  for (var i = 0; i < Modernizr._q.length; i++) {
    Modernizr._q[i]();
  }

  // Leak Modernizr namespace
  window.Modernizr = Modernizr;


;

})(window, document);

/**
 * _browser.js
 * Display a message to non supported browser.
 *
 * If needed you can update the markup of the message
 * and/or the body of browserIsCompatible() function to adjust the test based on which browsers you want to support.
 */

$(function() {
  'use strict';

  var html = '<div class="c-browser">\
                <strong class="c-browser__title">Votre version de navigateur est obsolète.</strong>\
                <p class="c-browser__content">Mettez à jour votre navigateur pour afficher correctement ce site Web.</p>\
                <div class="c-browser__action">\
                  <a href="http://outdatedbrowser.com/fr" class="c-button c-button--primary c-browser__button">\
                    <span class="c-button__text">Mettre à jour maintenant</span>\
                  </a>\
                </div>\
              </div>';

  function browserIsCompatible(){
    // By default we treat all browsers has compatible
    var isCompatible = true;

    /*
     * No IE versions supports @supports{} and if we rely on caniuse stats this feature is pretty well supported :
     * https://caniuse.com/#search=supports
     * So this must cover our comptaibility expectations (usually last 2 versions)
     */
    var cssSupports = 'CSS' in window && 'supports' in window.CSS || 'supportsCSS' in window;
    // Target IE11 only : https://stackoverflow.com/questions/21825157/internet-explorer-11-detection
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;

    // If doesn't support @supports{} and is not IE11
    if(!cssSupports && !isIE11){
      isCompatible = false;
    }

    return isCompatible;
  }

  // When DOM is ready, if browser is not supported then we display the disclaimer message.
  $(document).ready(function(){
    if(!browserIsCompatible()){
      $('body').prepend(html);
    }
  });

});

!function(root, factory) {
    "function" == typeof define && define.amd ? // AMD. Register as an anonymous module unless amdModuleId is set
    define([], function() {
        return root.svg4everybody = factory();
    }) : "object" == typeof module && module.exports ? // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    module.exports = factory() : root.svg4everybody = factory();
}(this, function() {
    /*! svg4everybody v2.1.9 | github.com/jonathantneal/svg4everybody */
    function embed(parent, svg, target) {
        // if the target exists
        if (target) {
            // create a document fragment to hold the contents of the target
            var fragment = document.createDocumentFragment(), viewBox = !svg.hasAttribute("viewBox") && target.getAttribute("viewBox");
            // conditionally set the viewBox on the svg
            viewBox && svg.setAttribute("viewBox", viewBox);
            // copy the contents of the clone into the fragment
            for (// clone the target
            var clone = target.cloneNode(!0); clone.childNodes.length; ) {
                fragment.appendChild(clone.firstChild);
            }
            // append the fragment into the svg
            parent.appendChild(fragment);
        }
    }
    function loadreadystatechange(xhr) {
        // listen to changes in the request
        xhr.onreadystatechange = function() {
            // if the request is ready
            if (4 === xhr.readyState) {
                // get the cached html document
                var cachedDocument = xhr._cachedDocument;
                // ensure the cached html document based on the xhr response
                cachedDocument || (cachedDocument = xhr._cachedDocument = document.implementation.createHTMLDocument(""), 
                cachedDocument.body.innerHTML = xhr.responseText, xhr._cachedTarget = {}), // clear the xhr embeds list and embed each item
                xhr._embeds.splice(0).map(function(item) {
                    // get the cached target
                    var target = xhr._cachedTarget[item.id];
                    // ensure the cached target
                    target || (target = xhr._cachedTarget[item.id] = cachedDocument.getElementById(item.id)), 
                    // embed the target into the svg
                    embed(item.parent, item.svg, target);
                });
            }
        }, // test the ready state change immediately
        xhr.onreadystatechange();
    }
    function svg4everybody(rawopts) {
        function oninterval() {
            // while the index exists in the live <use> collection
            for (// get the cached <use> index
            var index = 0; index < uses.length; ) {
                // get the current <use>
                var use = uses[index], parent = use.parentNode, svg = getSVGAncestor(parent), src = use.getAttribute("xlink:href") || use.getAttribute("href");
                if (!src && opts.attributeName && (src = use.getAttribute(opts.attributeName)), 
                svg && src) {
                    if (polyfill) {
                        if (!opts.validate || opts.validate(src, svg, use)) {
                            // remove the <use> element
                            parent.removeChild(use);
                            // parse the src and get the url and id
                            var srcSplit = src.split("#"), url = srcSplit.shift(), id = srcSplit.join("#");
                            // if the link is external
                            if (url.length) {
                                // get the cached xhr request
                                var xhr = requests[url];
                                // ensure the xhr request exists
                                xhr || (xhr = requests[url] = new XMLHttpRequest(), xhr.open("GET", url), xhr.send(), 
                                xhr._embeds = []), // add the svg and id as an item to the xhr embeds list
                                xhr._embeds.push({
                                    parent: parent,
                                    svg: svg,
                                    id: id
                                }), // prepare the xhr ready state change event
                                loadreadystatechange(xhr);
                            } else {
                                // embed the local id into the svg
                                embed(parent, svg, document.getElementById(id));
                            }
                        } else {
                            // increase the index when the previous value was not "valid"
                            ++index, ++numberOfSvgUseElementsToBypass;
                        }
                    }
                } else {
                    // increase the index when the previous value was not "valid"
                    ++index;
                }
            }
            // continue the interval
            (!uses.length || uses.length - numberOfSvgUseElementsToBypass > 0) && requestAnimationFrame(oninterval, 67);
        }
        var polyfill, opts = Object(rawopts), newerIEUA = /\bTrident\/[567]\b|\bMSIE (?:9|10)\.0\b/, webkitUA = /\bAppleWebKit\/(\d+)\b/, olderEdgeUA = /\bEdge\/12\.(\d+)\b/, edgeUA = /\bEdge\/.(\d+)\b/, inIframe = window.top !== window.self;
        polyfill = "polyfill" in opts ? opts.polyfill : newerIEUA.test(navigator.userAgent) || (navigator.userAgent.match(olderEdgeUA) || [])[1] < 10547 || (navigator.userAgent.match(webkitUA) || [])[1] < 537 || edgeUA.test(navigator.userAgent) && inIframe;
        // create xhr requests object
        var requests = {}, requestAnimationFrame = window.requestAnimationFrame || setTimeout, uses = document.getElementsByTagName("use"), numberOfSvgUseElementsToBypass = 0;
        // conditionally start the interval if the polyfill is active
        polyfill && oninterval();
    }
    function getSVGAncestor(node) {
        for (var svg = node; "svg" !== svg.nodeName.toLowerCase() && (svg = svg.parentNode); ) {}
        return svg;
    }
    return svg4everybody;
});
/**
 * requestAnimationFrame polyfill v1.0.1
 * requires Date.now
 *
 * © Polyfiller 2015
 * Released under the MIT license
 * github.com/Polyfiller/requestAnimationFrame
 */
window.requestAnimationFrame || function () {

    'use strict';

    window.requestAnimationFrame = window.msRequestAnimationFrame
    || window.mozRequestAnimationFrame
    || window.webkitRequestAnimationFrame
    || function () {

        var fps = 60;
        var delay = 1000 / fps;
        var animationStartTime = Date.now();
        var previousCallTime = animationStartTime;

        return function requestAnimationFrame(callback) {

            var requestTime = Date.now();
            var timeout = Math.max(0, delay - (requestTime - previousCallTime));
            var timeToCall = requestTime + timeout;

            previousCallTime = timeToCall;

            return window.setTimeout(function onAnimationFrame() {

                callback(timeToCall - animationStartTime);

            }, timeout);
        };
    }();

    window.cancelAnimationFrame = window.mozCancelAnimationFrame
    || window.webkitCancelAnimationFrame
    || window.cancelRequestAnimationFrame
    || window.msCancelRequestAnimationFrame
    || window.mozCancelRequestAnimationFrame
    || window.webkitCancelRequestAnimationFrame
    || function cancelAnimationFrame(id) {
           window.clearTimeout(id);
       };

}();


svg4everybody();

/**
 * External links
 */

// Open external links in new window
(function () {
  $(document).find('a[href]:not([href="#"])').each(function (index, link) {
    var isBlankable =
      !link.href.match(/^(mailto|tel)\:/) &&                                                       // Ignore mailto and tel
      (link.href.match(/\.(pdf|xls|doc|ppt)/) ||                                                   // Enable if document
        (link.hostname != location.hostname && (!link.download || !link.target || !link.rel)));    // Enable if different domain with no download, target or rel attributes

    if (isBlankable) {
      link.target = "_blank";
      link.rel = "noopener";
    }
  });
})();



/**


 * Copyright 2016 Google Inc. All Rights Reserved.


 *


 * Licensed under the W3C SOFTWARE AND DOCUMENT NOTICE AND LICENSE.


 *


 *  https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document


 *


 */





(function(window, document) {


'use strict';








// Exits early if all IntersectionObserver and IntersectionObserverEntry


// features are natively supported.


if ('IntersectionObserver' in window &&


    'IntersectionObserverEntry' in window &&


    'intersectionRatio' in window.IntersectionObserverEntry.prototype) {





  // Minimal polyfill for Edge 15's lack of `isIntersecting`


  // See: https://github.com/w3c/IntersectionObserver/issues/211


  if (!('isIntersecting' in window.IntersectionObserverEntry.prototype)) {


    Object.defineProperty(window.IntersectionObserverEntry.prototype,


      'isIntersecting', {


      get: function () {


        return this.intersectionRatio > 0;


      }


    });


  }


  return;


}








/**


 * An IntersectionObserver registry. This registry exists to hold a strong


 * reference to IntersectionObserver instances currently observing a target


 * element. Without this registry, instances without another reference may be


 * garbage collected.


 */


var registry = [];








/**


 * Creates the global IntersectionObserverEntry constructor.


 * https://w3c.github.io/IntersectionObserver/#intersection-observer-entry


 * @param {Object} entry A dictionary of instance properties.


 * @constructor


 */


function IntersectionObserverEntry(entry) {


  this.time = entry.time;


  this.target = entry.target;


  this.rootBounds = entry.rootBounds;


  this.boundingClientRect = entry.boundingClientRect;


  this.intersectionRect = entry.intersectionRect || getEmptyRect();


  this.isIntersecting = !!entry.intersectionRect;





  // Calculates the intersection ratio.


  var targetRect = this.boundingClientRect;


  var targetArea = targetRect.width * targetRect.height;


  var intersectionRect = this.intersectionRect;


  var intersectionArea = intersectionRect.width * intersectionRect.height;





  // Sets intersection ratio.


  if (targetArea) {


    // Round the intersection ratio to avoid floating point math issues:


    // https://github.com/w3c/IntersectionObserver/issues/324


    this.intersectionRatio = Number((intersectionArea / targetArea).toFixed(4));


  } else {


    // If area is zero and is intersecting, sets to 1, otherwise to 0


    this.intersectionRatio = this.isIntersecting ? 1 : 0;


  }


}








/**


 * Creates the global IntersectionObserver constructor.


 * https://w3c.github.io/IntersectionObserver/#intersection-observer-interface


 * @param {Function} callback The function to be invoked after intersection


 *     changes have queued. The function is not invoked if the queue has


 *     been emptied by calling the `takeRecords` method.


 * @param {Object=} opt_options Optional configuration options.


 * @constructor


 */


function IntersectionObserver(callback, opt_options) {





  var options = opt_options || {};





  if (typeof callback != 'function') {


    throw new Error('callback must be a function');


  }





  if (options.root && options.root.nodeType != 1) {


    throw new Error('root must be an Element');


  }





  // Binds and throttles `this._checkForIntersections`.


  this._checkForIntersections = throttle(


      this._checkForIntersections.bind(this), this.THROTTLE_TIMEOUT);





  // Private properties.


  this._callback = callback;


  this._observationTargets = [];


  this._queuedEntries = [];


  this._rootMarginValues = this._parseRootMargin(options.rootMargin);





  // Public properties.


  this.thresholds = this._initThresholds(options.threshold);


  this.root = options.root || null;


  this.rootMargin = this._rootMarginValues.map(function(margin) {


    return margin.value + margin.unit;


  }).join(' ');


}








/**


 * The minimum interval within which the document will be checked for


 * intersection changes.


 */


IntersectionObserver.prototype.THROTTLE_TIMEOUT = 100;








/**


 * The frequency in which the polyfill polls for intersection changes.


 * this can be updated on a per instance basis and must be set prior to


 * calling `observe` on the first target.


 */


IntersectionObserver.prototype.POLL_INTERVAL = null;





/**


 * Use a mutation observer on the root element


 * to detect intersection changes.


 */


IntersectionObserver.prototype.USE_MUTATION_OBSERVER = true;








/**


 * Starts observing a target element for intersection changes based on


 * the thresholds values.


 * @param {Element} target The DOM element to observe.


 */


IntersectionObserver.prototype.observe = function(target) {


  var isTargetAlreadyObserved = this._observationTargets.some(function(item) {


    return item.element == target;


  });





  if (isTargetAlreadyObserved) {


    return;


  }





  if (!(target && target.nodeType == 1)) {


    throw new Error('target must be an Element');


  }





  this._registerInstance();


  this._observationTargets.push({element: target, entry: null});


  this._monitorIntersections();


  this._checkForIntersections();


};








/**


 * Stops observing a target element for intersection changes.


 * @param {Element} target The DOM element to observe.


 */


IntersectionObserver.prototype.unobserve = function(target) {


  this._observationTargets =


      this._observationTargets.filter(function(item) {





    return item.element != target;


  });


  if (!this._observationTargets.length) {


    this._unmonitorIntersections();


    this._unregisterInstance();


  }


};








/**


 * Stops observing all target elements for intersection changes.


 */


IntersectionObserver.prototype.disconnect = function() {


  this._observationTargets = [];


  this._unmonitorIntersections();


  this._unregisterInstance();


};








/**


 * Returns any queue entries that have not yet been reported to the


 * callback and clears the queue. This can be used in conjunction with the


 * callback to obtain the absolute most up-to-date intersection information.


 * @return {Array} The currently queued entries.


 */


IntersectionObserver.prototype.takeRecords = function() {


  var records = this._queuedEntries.slice();


  this._queuedEntries = [];


  return records;


};








/**


 * Accepts the threshold value from the user configuration object and


 * returns a sorted array of unique threshold values. If a value is not


 * between 0 and 1 and error is thrown.


 * @private


 * @param {Array|number=} opt_threshold An optional threshold value or


 *     a list of threshold values, defaulting to [0].


 * @return {Array} A sorted list of unique and valid threshold values.


 */


IntersectionObserver.prototype._initThresholds = function(opt_threshold) {


  var threshold = opt_threshold || [0];


  if (!Array.isArray(threshold)) threshold = [threshold];





  return threshold.sort().filter(function(t, i, a) {


    if (typeof t != 'number' || isNaN(t) || t < 0 || t > 1) {


      throw new Error('threshold must be a number between 0 and 1 inclusively');


    }


    return t !== a[i - 1];


  });


};








/**


 * Accepts the rootMargin value from the user configuration object


 * and returns an array of the four margin values as an object containing


 * the value and unit properties. If any of the values are not properly


 * formatted or use a unit other than px or %, and error is thrown.


 * @private


 * @param {string=} opt_rootMargin An optional rootMargin value,


 *     defaulting to '0px'.


 * @return {Array<Object>} An array of margin objects with the keys


 *     value and unit.


 */


IntersectionObserver.prototype._parseRootMargin = function(opt_rootMargin) {


  var marginString = opt_rootMargin || '0px';


  var margins = marginString.split(/\s+/).map(function(margin) {


    var parts = /^(-?\d*\.?\d+)(px|%)$/.exec(margin);


    if (!parts) {


      throw new Error('rootMargin must be specified in pixels or percent');


    }


    return {value: parseFloat(parts[1]), unit: parts[2]};


  });





  // Handles shorthand.


  margins[1] = margins[1] || margins[0];


  margins[2] = margins[2] || margins[0];


  margins[3] = margins[3] || margins[1];





  return margins;


};








/**


 * Starts polling for intersection changes if the polling is not already


 * happening, and if the page's visibility state is visible.


 * @private


 */


IntersectionObserver.prototype._monitorIntersections = function() {


  if (!this._monitoringIntersections) {


    this._monitoringIntersections = true;





    // If a poll interval is set, use polling instead of listening to


    // resize and scroll events or DOM mutations.


    if (this.POLL_INTERVAL) {


      this._monitoringInterval = setInterval(


          this._checkForIntersections, this.POLL_INTERVAL);


    }


    else {


      addEvent(window, 'resize', this._checkForIntersections, true);


      addEvent(document, 'scroll', this._checkForIntersections, true);





      if (this.USE_MUTATION_OBSERVER && 'MutationObserver' in window) {


        this._domObserver = new MutationObserver(this._checkForIntersections);


        this._domObserver.observe(document, {


          attributes: true,


          childList: true,


          characterData: true,


          subtree: true


        });


      }


    }


  }


};








/**


 * Stops polling for intersection changes.


 * @private


 */


IntersectionObserver.prototype._unmonitorIntersections = function() {


  if (this._monitoringIntersections) {


    this._monitoringIntersections = false;





    clearInterval(this._monitoringInterval);


    this._monitoringInterval = null;





    removeEvent(window, 'resize', this._checkForIntersections, true);


    removeEvent(document, 'scroll', this._checkForIntersections, true);





    if (this._domObserver) {


      this._domObserver.disconnect();


      this._domObserver = null;


    }


  }


};








/**


 * Scans each observation target for intersection changes and adds them


 * to the internal entries queue. If new entries are found, it


 * schedules the callback to be invoked.


 * @private


 */


IntersectionObserver.prototype._checkForIntersections = function() {


  var rootIsInDom = this._rootIsInDom();


  var rootRect = rootIsInDom ? this._getRootRect() : getEmptyRect();





  this._observationTargets.forEach(function(item) {


    var target = item.element;


    var targetRect = getBoundingClientRect(target);


    var rootContainsTarget = this._rootContainsTarget(target);


    var oldEntry = item.entry;


    var intersectionRect = rootIsInDom && rootContainsTarget &&


        this._computeTargetAndRootIntersection(target, rootRect);





    var newEntry = item.entry = new IntersectionObserverEntry({


      time: now(),


      target: target,


      boundingClientRect: targetRect,


      rootBounds: rootRect,


      intersectionRect: intersectionRect


    });





    if (!oldEntry) {


      this._queuedEntries.push(newEntry);


    } else if (rootIsInDom && rootContainsTarget) {


      // If the new entry intersection ratio has crossed any of the


      // thresholds, add a new entry.


      if (this._hasCrossedThreshold(oldEntry, newEntry)) {


        this._queuedEntries.push(newEntry);


      }


    } else {


      // If the root is not in the DOM or target is not contained within


      // root but the previous entry for this target had an intersection,


      // add a new record indicating removal.


      if (oldEntry && oldEntry.isIntersecting) {


        this._queuedEntries.push(newEntry);


      }


    }


  }, this);





  if (this._queuedEntries.length) {


    this._callback(this.takeRecords(), this);


  }


};








/**


 * Accepts a target and root rect computes the intersection between then


 * following the algorithm in the spec.


 * TODO(philipwalton): at this time clip-path is not considered.


 * https://w3c.github.io/IntersectionObserver/#calculate-intersection-rect-algo


 * @param {Element} target The target DOM element


 * @param {Object} rootRect The bounding rect of the root after being


 *     expanded by the rootMargin value.


 * @return {?Object} The final intersection rect object or undefined if no


 *     intersection is found.


 * @private


 */


IntersectionObserver.prototype._computeTargetAndRootIntersection =


    function(target, rootRect) {





  // If the element isn't displayed, an intersection can't happen.


  if (window.getComputedStyle(target).display == 'none') return;





  var targetRect = getBoundingClientRect(target);


  var intersectionRect = targetRect;


  var parent = getParentNode(target);


  var atRoot = false;





  while (!atRoot) {


    var parentRect = null;


    var parentComputedStyle = parent.nodeType == 1 ?


        window.getComputedStyle(parent) : {};





    // If the parent isn't displayed, an intersection can't happen.


    if (parentComputedStyle.display == 'none') return;





    if (parent == this.root || parent == document) {


      atRoot = true;


      parentRect = rootRect;


    } else {


      // If the element has a non-visible overflow, and it's not the <body>


      // or <html> element, update the intersection rect.


      // Note: <body> and <html> cannot be clipped to a rect that's not also


      // the document rect, so no need to compute a new intersection.


      if (parent != document.body &&


          parent != document.documentElement &&


          parentComputedStyle.overflow != 'visible') {


        parentRect = getBoundingClientRect(parent);


      }


    }





    // If either of the above conditionals set a new parentRect,


    // calculate new intersection data.


    if (parentRect) {


      intersectionRect = computeRectIntersection(parentRect, intersectionRect);





      if (!intersectionRect) break;


    }


    parent = getParentNode(parent);


  }


  return intersectionRect;


};








/**


 * Returns the root rect after being expanded by the rootMargin value.


 * @return {Object} The expanded root rect.


 * @private


 */


IntersectionObserver.prototype._getRootRect = function() {


  var rootRect;


  if (this.root) {


    rootRect = getBoundingClientRect(this.root);


  } else {


    // Use <html>/<body> instead of window since scroll bars affect size.


    var html = document.documentElement;


    var body = document.body;


    rootRect = {


      top: 0,


      left: 0,


      right: html.clientWidth || body.clientWidth,


      width: html.clientWidth || body.clientWidth,


      bottom: html.clientHeight || body.clientHeight,


      height: html.clientHeight || body.clientHeight


    };


  }


  return this._expandRectByRootMargin(rootRect);


};








/**


 * Accepts a rect and expands it by the rootMargin value.


 * @param {Object} rect The rect object to expand.


 * @return {Object} The expanded rect.


 * @private


 */


IntersectionObserver.prototype._expandRectByRootMargin = function(rect) {


  var margins = this._rootMarginValues.map(function(margin, i) {


    return margin.unit == 'px' ? margin.value :


        margin.value * (i % 2 ? rect.width : rect.height) / 100;


  });


  var newRect = {


    top: rect.top - margins[0],


    right: rect.right + margins[1],


    bottom: rect.bottom + margins[2],


    left: rect.left - margins[3]


  };


  newRect.width = newRect.right - newRect.left;


  newRect.height = newRect.bottom - newRect.top;





  return newRect;


};








/**


 * Accepts an old and new entry and returns true if at least one of the


 * threshold values has been crossed.


 * @param {?IntersectionObserverEntry} oldEntry The previous entry for a


 *    particular target element or null if no previous entry exists.


 * @param {IntersectionObserverEntry} newEntry The current entry for a


 *    particular target element.


 * @return {boolean} Returns true if a any threshold has been crossed.


 * @private


 */


IntersectionObserver.prototype._hasCrossedThreshold =


    function(oldEntry, newEntry) {





  // To make comparing easier, an entry that has a ratio of 0


  // but does not actually intersect is given a value of -1


  var oldRatio = oldEntry && oldEntry.isIntersecting ?


      oldEntry.intersectionRatio || 0 : -1;


  var newRatio = newEntry.isIntersecting ?


      newEntry.intersectionRatio || 0 : -1;





  // Ignore unchanged ratios


  if (oldRatio === newRatio) return;





  for (var i = 0; i < this.thresholds.length; i++) {


    var threshold = this.thresholds[i];





    // Return true if an entry matches a threshold or if the new ratio


    // and the old ratio are on the opposite sides of a threshold.


    if (threshold == oldRatio || threshold == newRatio ||


        threshold < oldRatio !== threshold < newRatio) {


      return true;


    }


  }


};








/**


 * Returns whether or not the root element is an element and is in the DOM.


 * @return {boolean} True if the root element is an element and is in the DOM.


 * @private


 */


IntersectionObserver.prototype._rootIsInDom = function() {


  return !this.root || containsDeep(document, this.root);


};








/**


 * Returns whether or not the target element is a child of root.


 * @param {Element} target The target element to check.


 * @return {boolean} True if the target element is a child of root.


 * @private


 */


IntersectionObserver.prototype._rootContainsTarget = function(target) {


  return containsDeep(this.root || document, target);


};








/**


 * Adds the instance to the global IntersectionObserver registry if it isn't


 * already present.


 * @private


 */


IntersectionObserver.prototype._registerInstance = function() {


  if (registry.indexOf(this) < 0) {


    registry.push(this);


  }


};








/**


 * Removes the instance from the global IntersectionObserver registry.


 * @private


 */


IntersectionObserver.prototype._unregisterInstance = function() {


  var index = registry.indexOf(this);


  if (index != -1) registry.splice(index, 1);


};








/**


 * Returns the result of the performance.now() method or null in browsers


 * that don't support the API.


 * @return {number} The elapsed time since the page was requested.


 */


function now() {


  return window.performance && performance.now && performance.now();


}








/**


 * Throttles a function and delays its execution, so it's only called at most


 * once within a given time period.


 * @param {Function} fn The function to throttle.


 * @param {number} timeout The amount of time that must pass before the


 *     function can be called again.


 * @return {Function} The throttled function.


 */


function throttle(fn, timeout) {


  var timer = null;


  return function () {


    if (!timer) {


      timer = setTimeout(function() {


        fn();


        timer = null;


      }, timeout);


    }


  };


}








/**


 * Adds an event handler to a DOM node ensuring cross-browser compatibility.


 * @param {Node} node The DOM node to add the event handler to.


 * @param {string} event The event name.


 * @param {Function} fn The event handler to add.


 * @param {boolean} opt_useCapture Optionally adds the even to the capture


 *     phase. Note: this only works in modern browsers.


 */


function addEvent(node, event, fn, opt_useCapture) {


  if (typeof node.addEventListener == 'function') {


    node.addEventListener(event, fn, opt_useCapture || false);


  }


  else if (typeof node.attachEvent == 'function') {


    node.attachEvent('on' + event, fn);


  }


}








/**


 * Removes a previously added event handler from a DOM node.


 * @param {Node} node The DOM node to remove the event handler from.


 * @param {string} event The event name.


 * @param {Function} fn The event handler to remove.


 * @param {boolean} opt_useCapture If the event handler was added with this


 *     flag set to true, it should be set to true here in order to remove it.


 */


function removeEvent(node, event, fn, opt_useCapture) {


  if (typeof node.removeEventListener == 'function') {


    node.removeEventListener(event, fn, opt_useCapture || false);


  }


  else if (typeof node.detatchEvent == 'function') {


    node.detatchEvent('on' + event, fn);


  }


}








/**


 * Returns the intersection between two rect objects.


 * @param {Object} rect1 The first rect.


 * @param {Object} rect2 The second rect.


 * @return {?Object} The intersection rect or undefined if no intersection


 *     is found.


 */


function computeRectIntersection(rect1, rect2) {


  var top = Math.max(rect1.top, rect2.top);


  var bottom = Math.min(rect1.bottom, rect2.bottom);


  var left = Math.max(rect1.left, rect2.left);


  var right = Math.min(rect1.right, rect2.right);


  var width = right - left;


  var height = bottom - top;





  return (width >= 0 && height >= 0) && {


    top: top,


    bottom: bottom,


    left: left,


    right: right,


    width: width,


    height: height


  };


}








/**


 * Shims the native getBoundingClientRect for compatibility with older IE.


 * @param {Element} el The element whose bounding rect to get.


 * @return {Object} The (possibly shimmed) rect of the element.


 */


function getBoundingClientRect(el) {


  var rect;





  try {


    rect = el.getBoundingClientRect();


  } catch (err) {


    // Ignore Windows 7 IE11 "Unspecified error"


    // https://github.com/w3c/IntersectionObserver/pull/205


  }





  if (!rect) return getEmptyRect();





  // Older IE


  if (!(rect.width && rect.height)) {


    rect = {


      top: rect.top,


      right: rect.right,


      bottom: rect.bottom,


      left: rect.left,


      width: rect.right - rect.left,


      height: rect.bottom - rect.top


    };


  }


  return rect;


}








/**


 * Returns an empty rect object. An empty rect is returned when an element


 * is not in the DOM.


 * @return {Object} The empty rect.


 */


function getEmptyRect() {


  return {


    top: 0,


    bottom: 0,


    left: 0,


    right: 0,


    width: 0,


    height: 0


  };


}





/**


 * Checks to see if a parent element contains a child element (including inside


 * shadow DOM).


 * @param {Node} parent The parent element.


 * @param {Node} child The child element.


 * @return {boolean} True if the parent node contains the child node.


 */


function containsDeep(parent, child) {


  var node = child;


  while (node) {


    if (node == parent) return true;





    node = getParentNode(node);


  }


  return false;


}








/**


 * Gets the parent node of an element or its host element if the parent node


 * is a shadow root.


 * @param {Node} node The node whose parent to get.


 * @return {Node|null} The parent node or null if no parent exists.


 */


function getParentNode(node) {


  var parent = node.parentNode;





  if (parent && parent.nodeType == 11 && parent.host) {


    // If the parent is a shadow root, return the host element.


    return parent.host;


  }


  return parent;


}








// Exposes the constructors globally.


window.IntersectionObserver = IntersectionObserver;


window.IntersectionObserverEntry = IntersectionObserverEntry;





}(window, document));




(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    define(factory);
  } else if (typeof exports === 'object') {
    module.exports = factory(require, exports, module);
  } else {
    root.CountUp = factory();
  }
}(this, function(require, exports, module) {

/*

	countUp.js
	by @inorganik

*/

// target = id of html element or var of previously selected html element where counting occurs
// startVal = the value you want to begin at
// endVal = the value you want to arrive at
// decimals = number of decimal places, default 0
// duration = duration of animation in seconds, default 2
// options = optional object of options (see below)

var CountUp = function(target, startVal, endVal, decimals, duration, options) {

	var self = this;
	self.version = function () { return '1.9.3'; };
	
	// default options
	self.options = {
		useEasing: true, // toggle easing
		useGrouping: true, // 1,000,000 vs 1000000
		separator: ',', // character to use as a separator
		decimal: '.', // character to use as a decimal
		easingFn: easeOutExpo, // optional custom easing function, default is Robert Penner's easeOutExpo
		formattingFn: formatNumber, // optional custom formatting function, default is formatNumber above
		prefix: '', // optional text before the result
		suffix: '', // optional text after the result
		numerals: [] // optionally pass an array of custom numerals for 0-9
	};

	// extend default options with passed options object
	if (options && typeof options === 'object') {
		for (var key in self.options) {
			if (options.hasOwnProperty(key) && options[key] !== null) {
				self.options[key] = options[key];
			}
		}
	}

	if (self.options.separator === '') {
		self.options.useGrouping = false;
	}
	else {
		// ensure the separator is a string (formatNumber assumes this)
		self.options.separator = '' + self.options.separator;
	}

	// make sure requestAnimationFrame and cancelAnimationFrame are defined
	// polyfill for browsers without native support
	// by Opera engineer Erik Möller
	var lastTime = 0;
	var vendors = ['webkit', 'moz', 'ms', 'o'];
	for(var x = 0; x < vendors.length && !window.requestAnimationFrame; ++x) {
		window.requestAnimationFrame = window[vendors[x]+'RequestAnimationFrame'];
		window.cancelAnimationFrame = window[vendors[x]+'CancelAnimationFrame'] || window[vendors[x]+'CancelRequestAnimationFrame'];
	}
	if (!window.requestAnimationFrame) {
		window.requestAnimationFrame = function(callback, element) {
			var currTime = new Date().getTime();
			var timeToCall = Math.max(0, 16 - (currTime - lastTime));
			var id = window.setTimeout(function() { callback(currTime + timeToCall); }, timeToCall);
			lastTime = currTime + timeToCall;
			return id;
		};
	}
	if (!window.cancelAnimationFrame) {
		window.cancelAnimationFrame = function(id) {
			clearTimeout(id);
		};
	}

	function formatNumber(num) {
		var neg = (num < 0),
        	x, x1, x2, x3, i, len;
		num = Math.abs(num).toFixed(self.decimals);
		num += '';
		x = num.split('.');
		x1 = x[0];
		x2 = x.length > 1 ? self.options.decimal + x[1] : '';
		if (self.options.useGrouping) {
			x3 = '';
			for (i = 0, len = x1.length; i < len; ++i) {
				if (i !== 0 && ((i % 3) === 0)) {
					x3 = self.options.separator + x3;
				}
				x3 = x1[len - i - 1] + x3;
			}
			x1 = x3;
		}
		// optional numeral substitution
		if (self.options.numerals.length) {
			x1 = x1.replace(/[0-9]/g, function(w) {
				return self.options.numerals[+w];
			})
			x2 = x2.replace(/[0-9]/g, function(w) {
				return self.options.numerals[+w];
			})
		}
		return (neg ? '-' : '') + self.options.prefix + x1 + x2 + self.options.suffix;
	}
	// Robert Penner's easeOutExpo
	function easeOutExpo(t, b, c, d) {
		return c * (-Math.pow(2, -10 * t / d) + 1) * 1024 / 1023 + b;
	}
	function ensureNumber(n) {
		return (typeof n === 'number' && !isNaN(n));
	}

	self.initialize = function() { 
		if (self.initialized) return true;
		
		self.error = '';
		self.d = (typeof target === 'string') ? document.getElementById(target) : target;
		if (!self.d) { 
			self.error = '[CountUp] target is null or undefined'
			return false;
		}
		self.startVal = Number(startVal);
		self.endVal = Number(endVal);
		// error checks
		if (ensureNumber(self.startVal) && ensureNumber(self.endVal)) {
			self.decimals = Math.max(0, decimals || 0);
			self.dec = Math.pow(10, self.decimals);
			self.duration = Number(duration) * 1000 || 2000;
			self.countDown = (self.startVal > self.endVal);
			self.frameVal = self.startVal;
			self.initialized = true;
			return true;
		}
		else {
			self.error = '[CountUp] startVal ('+startVal+') or endVal ('+endVal+') is not a number';
			return false;
		}
	};

	// Print value to target
	self.printValue = function(value) {
		var result = self.options.formattingFn(value);

		if (self.d.tagName === 'INPUT') {
			this.d.value = result;
		}
		else if (self.d.tagName === 'text' || self.d.tagName === 'tspan') {
			this.d.textContent = result;
		}
		else {
			this.d.innerHTML = result;
		}
	};

	self.count = function(timestamp) {

		if (!self.startTime) { self.startTime = timestamp; }

		self.timestamp = timestamp;
		var progress = timestamp - self.startTime;
		self.remaining = self.duration - progress;

		// to ease or not to ease
		if (self.options.useEasing) {
			if (self.countDown) {
				self.frameVal = self.startVal - self.options.easingFn(progress, 0, self.startVal - self.endVal, self.duration);
			} else {
				self.frameVal = self.options.easingFn(progress, self.startVal, self.endVal - self.startVal, self.duration);
			}
		} else {
			if (self.countDown) {
				self.frameVal = self.startVal - ((self.startVal - self.endVal) * (progress / self.duration));
			} else {
				self.frameVal = self.startVal + (self.endVal - self.startVal) * (progress / self.duration);
			}
		}

		// don't go past endVal since progress can exceed duration in the last frame
		if (self.countDown) {
			self.frameVal = (self.frameVal < self.endVal) ? self.endVal : self.frameVal;
		} else {
			self.frameVal = (self.frameVal > self.endVal) ? self.endVal : self.frameVal;
		}

		// decimal
		self.frameVal = Math.round(self.frameVal*self.dec)/self.dec;

		// format and print value
		self.printValue(self.frameVal);

		// whether to continue
		if (progress < self.duration) {
			self.rAF = requestAnimationFrame(self.count);
		} else {
			if (self.callback) self.callback();
		}
	};
	// start your animation
	self.start = function(callback) {
		if (!self.initialize()) return;
		self.callback = callback;
		self.rAF = requestAnimationFrame(self.count);
	};
	// toggles pause/resume animation
	self.pauseResume = function() {
		if (!self.paused) {
			self.paused = true;
			cancelAnimationFrame(self.rAF);
		} else {
			self.paused = false;
			delete self.startTime;
			self.duration = self.remaining;
			self.startVal = self.frameVal;
			requestAnimationFrame(self.count);
		}
	};
	// reset to startVal so animation can be run again
	self.reset = function() {
		self.paused = false;
		delete self.startTime;
		self.initialized = false;
		if (self.initialize()) {
			cancelAnimationFrame(self.rAF);
			self.printValue(self.startVal);
		}
	};
	// pass a new endVal and start animation
	self.update = function (newEndVal) {
		if (!self.initialize()) return;
		newEndVal = Number(newEndVal);
		if (!ensureNumber(newEndVal)) {
			self.error = '[CountUp] update() - new endVal is not a number: '+newEndVal;
			return;
		}
		self.error = '';
		if (newEndVal === self.frameVal) return;
		cancelAnimationFrame(self.rAF);
		self.paused = false;
		delete self.startTime;
		self.startVal = self.frameVal;
		self.endVal = newEndVal;
		self.countDown = (self.startVal > self.endVal);
		self.rAF = requestAnimationFrame(self.count);
	};

	// format startVal on initialization
	if (self.initialize()) self.printValue(self.startVal);
};

return CountUp;

}));

